module.exports = __webpack_public_path__ + "img/vip_table.aeeae571.png";